// @flow
import React from "react";
import type { FieldProps } from "redux-form";
import { formValues } from "redux-form";
import { LinearProgress, withStyles, lighten } from "@material-ui/core";
import RFInputField from "./RFInputField";

const BorderLinearProgress = withStyles({
    root: {
        height: 10,
        backgroundColor: lighten("#ff6c5c", 0.5),
    },
    bar: {
        borderRadius: 20,
        backgroundColor: "#ff6c5c",
    },
})(LinearProgress);

type InputFieldType = {
    inputComponent: Element,
    children: Element | Array<Element>,
    maxLength: number,
    description: string,
} & FieldProps;

const RFInputFieldProgress = (props: InputFieldType) => {
    const { input, maxLength, description } = props;
    const completed = description ? (description.length * 100) / maxLength : 0;
    return (
        <>
            <br />
            <br />
            <BorderLinearProgress variant="determinate" value={completed} />
            <br />
            <RFInputField
                multiline
                {...props}
                onChange={event => {
                    input.onChange(event.target.value);
                }}
            />
        </>
    );
};

export default formValues({ description: "description" })(RFInputFieldProgress);
